import React from 'react'
import N2FroalaBox from "./N2FroalaBox";

class AnnotationCommentBox extends React.Component {
  constructor(props) {
    super(props)
    this.handleMessageChange = this.handleMessageChange.bind(this)
  }

  handleMessageChange(text) {
    if (this.props.onChange) {
      this.props.onChange(text);
    }
  }

  commentOrAttachment() {
    if (this.props.attachment) {
      return (
        <div className="separator p-1 px-2">
          <img className='js-attachment-upload' src={`${this.props.attachment}`} style={{'width': '150px', 'height': '100%'}} />
        </div>
      );
    }
    return (
      <N2FroalaBox
        onChange={this.handleMessageChange}
        comment={this.props.comment}
      />
    );
  }

  render() {
    return this.props.readOnly ? null : this.commentOrAttachment()
  }
}

export default AnnotationCommentBox
